import { ClientState } from "./ClientState";
import { ISystemContext } from "./Context/SystemContext";
import { ITimeout, Timeout } from "./Context/Timeout";
import { Button } from "./IO";
import { AvailableGame } from "./MultigameAvailableGame";
import { AddMouseDownListener, Log, LogGroup, Scale, SetStyles ,MyPIXIContainer } from "./MyHelpers";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "./ResourceManager/ResourceManager";
import { ZIndex } from "./ZIndex";
import { Money } from "./api";
import { GameSelectedCallback } from "./menu/IGamesMenu";
import { SlotBonus } from "./slot/Bonus/SlotBonus";
import { DoubleUp } from "./slot/DoubleUp";
import { SlotGame } from "./slot/SlotGame";
import { StateMachine } from "./slot/StateMachine";

enum RobotPlayState {
    Unknown = "Unknown",

    GameMenu = "GameMenu",
    GameWaitDenomSelect = "GameWaitDenomSelect",
    GameIdle = "GameIdle",
    BuyBonus = "BuyBonus",

    GameSpin = "GameSpin",
    Bonus = "Bonus",
    BonusConfirmMessage = "BonusConfirmMessage",
    BonusPick = "BonusPick",
    BonusRun = "BonusRun",
    BonusRunIdle = "BonusRunIdle",

    DoubleUpPick = "DoubleUpPick",
    DoubleUpWait = "DoubleUpWait",
}


//type RobotGameSelectedCallback = (gameName: string) => void;
export type GameExitCallback = () => void;

export enum RobotPlayType
{
    RandomGame = "RandomGame",
    CurrentGame = "CurrentGame",
    SelectingGame = "SelectingGame",
    BuyBonus = "BuyBonus",
}

export interface RobotParams
{
    //noChange: boolean;
    playType: RobotPlayType;
}

export const RobotParamsDefault: Readonly<RobotParams> = {
    playType: RobotPlayType.RandomGame,
};

export class RobotPlay
{
    protected enabled: boolean = false;
    //protected running: boolean = false;

    protected basegameSpinReels: boolean = true;

    protected clientState: ClientState = null;
    protected logGroup: LogGroup = new LogGroup("RobotPlay");
    protected resid: ResourceIdentifier =  new ResourceIdentifier("","RobotPlay");

    protected stateMachine: StateMachine<RobotPlayState> = new StateMachine<RobotPlayState>(RobotPlayState.Unknown, this.logGroup, (state: RobotPlayState) => RobotPlayState[state]);

    protected view: HTMLElement = null;

    protected selectedGame: SlotGame = null;
    protected doubleUpGameSelected: DoubleUp = null;

    protected delayTimer: number = -1;

    protected numOfSpins: number = 0;
    protected readonly requiredSpins: number = 100;
    protected fastSpin: boolean = true;

    protected gameSelectedCalback: GameSelectedCallback = null;
    protected gameExitCalback: GameExitCallback = null;
    protected games: Map<string,AvailableGame> = new Map<string,AvailableGame>();

    protected gameSelectDelay: ITimeout = null;
    protected denomSelectDelay: ITimeout = null;
    protected runStartDelay: ITimeout = null;
    protected gameExitDelay: ITimeout = null;
    protected doubleUpGame: DoubleUp = null;

    protected readonly timers: ITimeout[] = [];
    protected readonly context: ISystemContext;

    protected robotParams: Readonly<RobotParams> = RobotParamsDefault;

    public static Instance: RobotPlay = null;

    public constructor(context: ISystemContext, clientState: ClientState, games: Map<string,AvailableGame>)
    {
        this.context = context.CreateSubContext("RobotPlay");
        this.clientState = clientState;
        this.games = games;

        this.stateMachine.SetStateChangeCallback((oldState, newState) => {
            // Log.Debug(this.logGroup, "Changed state " + RobotPlayState[oldState] + " => " + RobotPlayState[newState]);
        });

        this.view = document.createElement("div");
        this.view.classList.add("RobotPlay");

        SetStyles(this.view, {
            position: "absolute",
            display: "none",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            fontFamily: "NotoSansDisplay-ExtraBold",
            top:"0px",
            color: "red",
            fontSize: Scale.Xpx(100),
            lineHeight: Scale.Xpx(100),
            textAlign: "center",
            zIndex: ""+ ZIndex.Robot,
            
            //textStroke: "2px black",
        });

        this.view.innerHTML = "ROBOT PLAY";

        AddMouseDownListener(this.view, (ev) => this.Disable())

        this.gameSelectDelay = this.context.TimingContext().CreateTimeout(this.resid.Add("gameSelectDelay").ID(), 1000, ()=>{ 
            this.SelectGame();
        });
        this.timers.push(this.gameSelectDelay);

        this.denomSelectDelay = this.context.TimingContext().CreateTimeout(this.resid.Add("denomSelectDelay").ID(), 3000, ()=>{ 
            // Log.Debug(this.logGroup,"Robot selected denom:");
            this.selectedGame.SelectBet2(Math.floor(Math.random() * this.selectedGame.InitData.EnabledBets.length));
            this.runStartDelay.Start();
        });
        this.timers.push(this.denomSelectDelay);

        this.runStartDelay = this.context.TimingContext().CreateTimeout(this.resid.Add("runStartDelay").ID(), 2000, ()=>{ 
            this.RunStart();
        });
        this.timers.push(this.runStartDelay);

        this.spinDelay = this.context.TimingContext().CreateTimeout(this.resid.Add("spinDelay").ID(), 100, () => {
            // Log.Debug(this.logGroup, "RunStart() Spinning");
            if (this.selectedGame)
            {
                this.selectedGame.Spin();
            }
        });
        this.timers.push(this.spinDelay);

        this.doubleUpDelay = this.context.TimingContext().CreateTimeout("doubleUpDelay", 100, async () => {

            if (!this.selectedGame)
            {
                Log.Error(this.logGroup, "doubleUpDelay() selectedGame is null");
                return;
            }

            this.selectedGame.OnButtonChanged(Button.ButtonDoubleUp, true);
            this.selectedGame.OnButtonChanged(Button.ButtonDoubleUp, false);
        });


        //   this.buyBonusDelay = this.context.TimingContext().CreateTimeout("buyBonus", 100, async () => {

        //     if (!this.selectedGame)
        //     {
        //         Log.Error(this.logGroup, "buyBonus() selectedGame is null");
        //         return;
        //     }

        //     this.selectedGame.BuyBonusRobotTestIt();
        // });

        this.timers.push(this.doubleUpDelay);

        this.confirmDelay = this.context.TimingContext().CreateTimeout(this.resid.Add("confirmDelay").ID(), 1000, () => {
            this.bonus?.Confirm();
        });
        this.timers.push(this.confirmDelay);

        this.pickDelay = this.context.TimingContext().CreateTimeout(this.resid.Add("pickDelay").ID(), 500, () => {
            this.bonus?.OnPicked(this.elementToPickIndex);
        });
        this.timers.push(this.pickDelay);
        

        this.stopDelay = this.context.TimingContext().CreateTimeout(this.resid.Add("stopDelay").ID(), 2000, () => {
            this.Hide();
        });
        //this.timers.push(this.stopDelay);

        // this.gameExitDelay = this.context.TimingContext().CreateTimeout(this.resid.Add("gameExit").ID(), 1000, () => {
        //     if (this.selectedGame)
        //     {
        //         this.selectedGame.GamesMenu();
        //     }
        // });

        this.gameExitDelay = this.context.TimingContext().CreateTimeout(this.resid.Add("gameExit").ID(), 1000, () => {
            if (this.selectedGame)
            {
                this.selectedGame.GamesMenu();
            }
        });
        this.timers.push(this.gameExitDelay);

        RobotPlay.Instance = this;
    }

    public PrepareResources(resourceManager: IWriteOnlyResourceManager): void
    {

    }

    public ResourcesLoaded(resourceManager: IReadOnlyResourceManager): void
    {

    }

    public View(): HTMLElement
    {
        return this.view;
    }

    protected stopDelay: ITimeout = null;


    protected readonly startActionMap: Map<RobotPlayState, () => void> = new Map<RobotPlayState, () => void>([
        [RobotPlayState.GameMenu, () => this.gameSelectDelay.Start()],
        [RobotPlayState.GameIdle, () => {
            if (this.robotParams.playType == RobotPlayType.SelectingGame)
            {
                this.gameExitDelay.Start();
            }
            else
            {
                this.runStartDelay.Start();
            }
        }],
        [RobotPlayState.GameSpin, () => { /* nothing to do, wait for spin end */}],
        [RobotPlayState.Bonus, () => { /* nothing to do, wait for spin end */}],
        [RobotPlayState.GameWaitDenomSelect, () => this.denomSelectDelay.Start()],
        [RobotPlayState.BonusConfirmMessage, () => this.confirmDelay.Start()],
        [RobotPlayState.DoubleUpPick, () => this.InteralPlayDoubleUpGame()],
    ])


    public Enable(robotParams: RobotParams = null): void
    {

        this.robotParams = robotParams ?? RobotParamsDefault;

        if (!this.CanEnable())
        {
            Log.Debug(this.logGroup, "Can't enable robot");
            return;
        }

        this.enabled = true;
        this.numOfSpins = 0;
        this.Show();

        if (this.robotParams.playType == RobotPlayType.RandomGame)
        {
            this.view.innerHTML = `ROBOT PLAY<br />RANDOM GAME ${this.requiredSpins} SPINS`;
        }
        else if (this.robotParams.playType == RobotPlayType.CurrentGame)
        {
            this.view.innerHTML = `ROBOT PLAY<br />SINGLE GAME`;
        }
        else if (this.robotParams.playType == RobotPlayType.SelectingGame)
        {
            this.view.innerHTML = `ROBOT PLAY<br />GAME SELECT`;
        }
        
        this.stopDelay.Stop();

        const action = this.startActionMap.get(this.stateMachine.State());
        if (!action)
        {
            this.InternalDisable(`CAN'T START ROBOT PLAY<br />STATE: ${this.stateMachine.State()}`);
            return;
        }
        
        action();
    }

    protected InternalDisable(message: string): void
    {
        this.enabled = false;

        // stop all timers
        this.timers.forEach(t => t.Stop());

        this.view.innerHTML = message ?? "STOPPING ROBOT PLAY";
        this.stopDelay.Start();
    }

    public Disable(): void
    {
        if (!this.enabled)
        {
            return;
        }

        this.InternalDisable("STOPPING ROBOT PLAY");
    }

    public IsEnabled(): boolean
    {
        return this.enabled;
    }

    public CanEnable(): boolean
    {

        if (this.startActionMap.has(this.stateMachine.State()))
        {
            return true;
        }

        return false;
    }

    protected RunStart(): void
    {
        if (!this.enabled)
        {
            return;
        }

        if (!this.selectedGame)
        {
            Log.Error(this.logGroup, "Can't start,no game selected");
            return;
        }

        // Log.Debug(this.logGroup, "RunStart()");

            

        if (this.stateMachine.State() == RobotPlayState.GameIdle)
        {
            // Log.Debug(this.logGroup, "NumOfSpins: " + this.numOfSpins);
            this.spinDelay.Start();
        }
        else if (this.stateMachine.State() == RobotPlayState.BonusPick)
        {
            this.BonusPick(this.page, this.availablePicks);
        }
        else if (this.stateMachine.State() == RobotPlayState.BonusConfirmMessage)
        {
            this.BonusConfirm(this.confirmWhat);
        }
        else if (this.stateMachine.State() == RobotPlayState.Bonus)
        {
            this.bonus?.Spin();

            // if (this.bonus != null)
            // {
                
            // }
            // else
            // {
            // 	Log.Error(this.logGroup, "In bonus, but no bonus is set?");
            // }
        }
        else if (this.stateMachine.IsState(RobotPlayState.DoubleUpPick))
        {
            this.InteralPlayDoubleUpGame();
        }
        else
        {
            Log.Error(this.logGroup, "Can't start, current state: " + RobotPlayState[this.stateMachine.State()]);
        }
    }

    public OnGameSelected(slotGame: SlotGame)
    {
        // Log.Debug(this.logGroup,"Robot in game:");
        
        this.gameSelectDelay.Stop();
        
        this.selectedGame = slotGame;
        this.stateMachine.ChangeState(RobotPlayState.GameWaitDenomSelect);

        if (!this.enabled)
        {
            return;
        }

        if (this.robotParams.playType == RobotPlayType.SelectingGame)
        {
            // exit game
            this.gameExitDelay.Start();
        }
        else
        {
            // select denom
            this.denomSelectDelay.Start();
        }
    }

	
	public OnBetSelected()
	{
		Log.Debug(this.logGroup,"OnBetSelected()");

        this.denomSelectDelay.Stop();

        // first denom select
        if (this.stateMachine.State() == RobotPlayState.GameWaitDenomSelect)
        {
            this.stateMachine.ChangeState(RobotPlayState.GameIdle);

            if (this.enabled)
            {
                this.runStartDelay.Start();
            }
        }
        else
        {
            // denom changed
        }
	}

    public OnGameExit()
    {
        Log.Debug(this.logGroup,"OnGameExit()");

        this.spinDelay.Stop();
        this.gameExitDelay.Stop();

        this.stateMachine.ChangeState(RobotPlayState.GameMenu);
        this.selectedGame = null;;

        if (this.enabled)
        {
            this.gameSelectDelay.Start();
            this.numOfSpins = 0;
        }
    }

    protected Hide(): void
    {
        SetStyles(this.view, {display: "none"});
    }

    protected Show(): void
    {
        SetStyles(this.view, {display: "flex"});
    }

    protected spinDelay: ITimeout = null;
    protected doubleUpDelay: ITimeout = null;
    //protected buyBonusDelay: ITimeout = null;

    public OnSpinStopAvailable(): void
    {
        if (!this.enabled)
        {
            return;
        }

        if (this.fastSpin)
        {
            this.spinDelay.Start();
        }
    }

    public GameFinished(canPlayDoubleUp: boolean): boolean
    {
        if (this.stateMachine.IsState(RobotPlayState.GameMenu))
        {
            // we are in menu, games are loaded and entering idle state, calling game finished.
            return false;
        }

        Log.Debug(this.logGroup, "GameFinished() canPlayDoubleUp: " + canPlayDoubleUp);

        if (!this.stateMachine.IsState(RobotPlayState.GameIdle))
        {
            this.stateMachine.ChangeState(RobotPlayState.GameIdle);
        }

        if (!this.enabled || this.selectedGame == null)
        {
            return false;
        }

        let randomDoubleupPlay: boolean = Math.random() < 0.5;
        if (canPlayDoubleUp && randomDoubleupPlay)
        {
            this.doubleUpDelay.Start();
            return true;
        }

        // let buyBonusRobothack: boolean = Math.random() < 0.8;
        // if (buyBonusRobothack)
        // {
        //     this.buyBonusDelay.Start();
        //     return true;
        // }

        this.NextSpin();

        return true;
    }

    public DoubleUpStarted(doubleUpGame: DoubleUp)
    {
        this.doubleUpGame = doubleUpGame;
        if (!this.stateMachine.IsState(RobotPlayState.DoubleUpWait))
        {
            this.stateMachine.ChangeState(RobotPlayState.DoubleUpWait);
        }
    }

    private NextSpin()
    {
        Log.Debug(this.logGroup, "NextSpin()");

        if (this.clientState.Balance() < this.selectedGame.GetSelectedBet().TotalBetCents.InCents)
        {
            Log.Debug(this.logGroup, "NextSpin() Not enough money to play");
            return;
        }


        this.numOfSpins++;

        // no changes, play next spin
        if (this.robotParams.playType == RobotPlayType.CurrentGame)
        {
            this.spinDelay.Start();
            return;
        }

        if(this.numOfSpins < this.requiredSpins)
        {
            // not enough spins, play next spin
            this.spinDelay.Start();
            return;
        }
        
        this.gameExitDelay.Start();
    }

    public GameSpinAccepted(): void
    {
        // Log.Debug(this.logGroup, "GameSpinAccepted() Spin accepted");
        this.stateMachine.ChangeState(RobotPlayState.GameSpin);
    }


    protected bonus: SlotBonus = null;
    protected bonusPageIndex = -1;
    protected bonusPickedIndices: number[] = [];
    public BonusStarted(bonus: SlotBonus): void
    {
        // Log.Debug(this.logGroup, "BonusStarted() " + bonus.Name());
        this.bonus = bonus;
        this.bonusPageIndex = -1;
        this.bonusPickedIndices = [];

        this.stateMachine.ChangeState(RobotPlayState.Bonus);
    }

    public BonusRunStopAvailable()
    {
        if (!this.enabled)
        {
            return;
        }

        if (this.fastSpin)
        {
            this.spinDelay.Start();
        }
    }

    public BonusEnded(): void
    {

        // Log.Debug(this.logGroup, "BonusEnded() ");
        this.bonus = null;
        this.bonusPageIndex = -1;
        this.bonusPickedIndices = [];

        this.stateMachine.ChangeState(RobotPlayState.GameSpin);
    }

    protected readonly confirmDelay: ITimeout = null;
    protected confirmWhat: string = "";
    public BonusConfirm(what: string): void
    {
        this.stateMachine.ChangeState(RobotPlayState.BonusConfirmMessage);
        this.confirmWhat = what;

        if (!this.enabled)
        {
            return;
        }

        this.confirmDelay.Start();
    }

    public BonusConfirmAccepted(): void
    {
        // Log.Debug(this.logGroup, "BonusConfirmAccepted() Confirm "+ this.confirmWhat  +" accepted");
        this.stateMachine.ChangeState(RobotPlayState.Bonus);
    }

    protected page: number = -1;
    protected availablePicks: number = -1;
    protected pickDelay: ITimeout = null;
    protected elementToPickIndex: number = -1;
    
    public BonusPick(page: number, availablePicks: number): void
    {
        this.stateMachine.ChangeState(RobotPlayState.BonusPick);

        this.page = page;
        this.availablePicks = availablePicks;

        if (!this.enabled)
        {
            return;
        }

        // if new page, reset picked indices
        if (page != this.bonusPageIndex)
        {
            // Log.Debug(this.logGroup, "BonusPick() new page index " + page);
            this.bonusPickedIndices = [];
            this.bonusPageIndex = page;
        }

        let pickIndex = Math.floor(Math.random() * availablePicks);
        
        // if picked already, find next pick
        while (this.bonusPickedIndices.includes(pickIndex))
        {
            pickIndex = (pickIndex +1) % availablePicks;
        }

        this.elementToPickIndex = pickIndex;
        this.bonusPickedIndices.push(pickIndex);
        this.pickDelay.Start();
    }

    
    public BonusPickAccepted(pickIndex: number): void
    {
        // Log.Debug(this.logGroup, "BonusPick() Pick accepted: " + pickIndex);

        this.pickDelay.Stop();
        this.stateMachine.ChangeState(RobotPlayState.Bonus);
    }

    public BonusRun(avaialbleRuns: number)
    {
        this.stateMachine.ChangeState(RobotPlayState.BonusRun);

        if (!this.enabled)
        {
            return;
        }
 
        if(avaialbleRuns != 0)
        {
            this.bonus?.Spin();
        }
    }

    public BonusRunAccepted()
    {
        // Log.Debug(this.logGroup, "Bonus run accepted");
        this.stateMachine.ChangeState(RobotPlayState.Bonus);
    }

    private SelectGame():void
    {
        // Log.Debug(this.logGroup,"Robot selected game:");
        this.gameSelectDelay.Stop();

		let selctedGameIndex = Math.floor(Math.random() * this.games.size);
		let gameNames = [...this.games.keys()];


        if(this.gameSelectedCalback != null)
        {
            this.gameSelectedCalback(gameNames[selctedGameIndex]);
        }
    }

    public GameSelectedCallback(callback: GameSelectedCallback): void 
    {
		this.gameSelectedCalback = callback;
    }
    
    public GameExitCallback(callback: GameExitCallback): void 
    {
		this.gameExitCalback = callback;
	}

    public PlayDoubleUpGame()
    {
        this.stateMachine.ChangeState(RobotPlayState.DoubleUpPick);

        if (!this.enabled || !this.doubleUpGame)
        {
            return;
        }
        
        this.InteralPlayDoubleUpGame();
    }

    protected InteralPlayDoubleUpGame()
    {
        let r = Math.random();
        if(r < 0.45)
        {
            this.doubleUpGame.pickBlackCard();
        }
        else if (r < 0.90)
        {
            this.doubleUpGame.pickRedCard();
        }
        else if (r < 0.95)
        {
            this.doubleUpGame.pickCollectHalf();
        }
        else
        {
            this.doubleUpGame.pickCollectAll();
        }
    }

    public DoubleUpPickAccepted()
    {
        if (!this.stateMachine.IsState(RobotPlayState.DoubleUpWait))
        {
            this.stateMachine.ChangeState(RobotPlayState.DoubleUpWait);
        }
    }
}

